import React from "react";

import { Form, Formik, FormikHelpers } from "formik";
import { object, string } from "yup";
import { BookDetailsFormWrapperValues } from "src/models/BookDetailsFormWrapper.model";
import BookDetailsForm from "./BookDetailsForm";
import { useOutletContext, useParams } from "react-router-dom";
import { useUpdateBookOrderByIdMutation } from "src/services/OfflineOrderService";
import { showToast } from "src/utils/showToaster";

const BookDetailsFormWrapper = () => {
  const { orderId } = useParams();
  const [offlineOrderData]: any = useOutletContext();
  const [updateBook] = useUpdateBookOrderByIdMutation();
  // Form Initial Values
  const initialValues: BookDetailsFormWrapperValues = {
    bookIssued: offlineOrderData?.bookIssued?.map((book: any) => ({
      bookId: book.bookId,
      bookName: book.bookName,
      isIssued: false,
      originallyIssued: book.isIssued,
    })),
  };

  // Validation Schema
  const validationSchema = object().shape({
    // bookIssued: object().shape({
    //   bookId: string().required(),
    //   isIssued: string().required(),
    //   }),
  });
  // Handle Submit
  const handleSubmit = (
    values: BookDetailsFormWrapperValues,
    { setSubmitting, resetForm }: FormikHelpers<BookDetailsFormWrapperValues>
  ) => {
    const updatedBooks = values.bookIssued.filter(
      (book) => book.isIssued && !book.originallyIssued
    );
    // let bookData = offlineOrderData?.bookIssued?.map((el: any) => el);
    const formattedValues = {
      bookIssued: updatedBooks.map((book) => ({
        bookId: book.bookId,
        isIssued: true,
      })),
    };
    updateBook({ id: orderId, body: formattedValues }).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {(formikProps) => (
        <Form>
          <BookDetailsForm
            formikProps={formikProps}
            bookIssued={offlineOrderData}
          />
        </Form>
      )}
    </Formik>
  );
};

export default BookDetailsFormWrapper;
